import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { getBetsEndpoint } from 'services/bets/bets.config';
import { Bets, BetsPayload } from 'services/bets/bets.type';

const initialState = {
  betsResponse: {
    bets: {},
  } as BetsPayload,
};

const betsReducer = createReducer(initialState, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;
    if (payload.resourceId === getBetsEndpoint) {
      state.betsResponse.totalPages = payload?.response?.data.totalPages;
      state.betsResponse.totalBets = payload?.response?.data.totalBets;
      let betsList = payload?.response?.data?.bets;

      if (Array.isArray(betsList)) {
        betsList = Object.fromEntries(
          betsList.map((betsRecord: Bets) => [betsRecord.tsn, betsRecord]),
        );
        state.betsResponse.bets = betsList;
      }
    }
  }),
);

export default betsReducer;
